import { Route, Switch } from "react-router-dom";
import React from "react";
import { CRM_DetalleScreen } from "./Detalle/CRM_DetalleScreen";
import { CRM_Solicitud_Credito } from "./SolicitudCredito/CRM_Solicitud_Credito";
import { CRM_Visitas_Screen } from "./Visitas/CRM_Visitas_Screen";
import { CRM_LineaCreditoScreen } from "./LineaCredito/CRM_LineaCreditoScreen";
import { CRM_Ref_Bancaria } from "./ReferenciaBancaria/CRM_Ref_Bancaria";
import { CRM_PAQ_Maquinaria } from "./PAQ_MAquinaria/CRM_PAQ_Maquinaria";
import { CRM_Dashboard } from "./CRM_Dashboard";
import { SolicitudCreditoListadoScreen } from "../Dashboard/Clientes/CapturasDashClientes/SolitudDeCredito/SolicitudCreditoListadoScreen";
import { DashGenerarSolicitudCredito } from "../Dashboard/Clientes/CapturasDashClientes/DashGenerarSolicitudCredito";
import { DashPedidoMaquinariascreen } from "../Dashboard/Clientes/CapturasDashClientes/PedidoMaquinaria/DashPedidoMaquinariascreen";
import DashCrearSolicitudCredito from "../Dashboard/Clientes/CapturasDashClientes/DashCrearSolicitudCredito";
import { CRM_ExpedienteDigital } from "./Detalle/CRM_ExpedienteDigital";
import { CRM_ReporteClientesActualizados } from "./Reportes/ClientesActualizados/CRM_ReporteClientesActualizados";
import { CRM_ReporteVisitasProgramadas } from "./Reportes/VisitasProgramadas/CRM_ReporteVisitasProgramadas";
import { CRM_ReporteGeolocalizacion } from "./Reportes/Geolocalizacion/CRM_ReporteGeolocalizacion";
import { CRM_ReporteCoberturaVisitas } from "./Reportes/CoberturaVisitas/CRM_ReporteCoberturaVisitas";
import { CRM_ReporteCoberturaCartera } from "./Reportes/CoberturaCartera/CRM_ReporteCoberturaCartera";
import { CRM_CotizacionesServicio } from "./CotizacionesServicio/CRM_CotizacionesServicio";
import { CRM_AgregarCotizacionServicio } from "./CotizacionesServicio/CRM_AgregarCotizacionServicio";
import { CRM_CatalogoServicio } from "./CotizacionesServicio/CRM_CatalogoServicio";
import CRM_ObjetivosMainScreen from "./Configuraciones/Objetivos/CRM_ObjetivosMainScreen";
import IndicadoresVisitasMainScreen from "./Configuraciones/IndicadoresVisitas/IndicadoresVisitasMainScreen";
import IndicadoresCotizacionesMainScreen from "./Configuraciones/IndicadoresCotizaciones/IndicadoresCotizacionesMainScreen";

export const CRMMainScreen = () => {
  return (
    <div className="main-container">
      <Switch>
        <Route path="/DashClientes/Main" component={CRM_Dashboard} />
        <Route path="/DashClientes/Detalle" component={CRM_DetalleScreen} />
        <Route path="/DashClientes/Solicitud_Credito" component={SolicitudCreditoListadoScreen} />
        <Route path="/DashClientes/solicitudcreditoGenerar" component={DashGenerarSolicitudCredito} />
        <Route path="/DashClientes/solicitudcredito/pedidos" component={DashPedidoMaquinariascreen} />
        <Route
          path="/DashClientes/solicitudcredito/crear"
          render={({ location }) => (
            <DashCrearSolicitudCredito
              idcliente={location.state?.idcliente}
              folio={location.state?.folio}
            />
          )}
        />
        <Route path="/DashClientes/expedientedigital" component={CRM_ExpedienteDigital} />
        <Route path="/DashClientes/Cotizaciones" component={CRM_Solicitud_Credito} />
        <Route path="/DashClientes/Visitas" component={CRM_Visitas_Screen} />
        <Route path="/DashClientes/Linea_Credito" component={CRM_LineaCreditoScreen} />
        <Route path="/DashClientes/Referencia_Bancaria" component={CRM_Ref_Bancaria} />
        <Route path="/DashClientes/ParqueMaquinaria" component={CRM_PAQ_Maquinaria} />
        <Route path="/DashClientes/Reportes/ClientesActualizados" component={CRM_ReporteClientesActualizados} />
        <Route path="/DashClientes/Reportes/VisitasProgramadas" component={CRM_ReporteVisitasProgramadas} />
        <Route path="/DashClientes/Reportes/Geolocalizacion" component={CRM_ReporteGeolocalizacion} />
        <Route path="/DashClientes/Reportes/CoberturaVisitas" component={CRM_ReporteCoberturaVisitas} />
        <Route path="/DashClientes/Reportes/CoberturaCartera" component={CRM_ReporteCoberturaCartera} />
        <Route path="/DashClientes/CotizacionesServicio/Agregar" component={CRM_AgregarCotizacionServicio} />
        <Route path="/DashClientes/CotizacionesServicio/Catalogo" component={CRM_CatalogoServicio} />
        <Route path="/DashClientes/CotizacionesServicio" component={CRM_CotizacionesServicio} />
        <Route path="/DashClientes/ConfiguracionObjetivos" component={CRM_ObjetivosMainScreen} />
        <Route path="/DashClientes/IndicadoresVisitas" component={IndicadoresVisitasMainScreen} />
        <Route path="/DashClientes/IndicadoresCotizaciones" component={IndicadoresCotizacionesMainScreen} />
      </Switch>
    </div>
  );
};
